import { appType } from "@/shared/lib/appType";

let notified = false;

/**
 * JS 부트스트랩 완료를 native 에 1회 통지한다 (BRIDGE_PROTOCOL §1.8).
 * native 는 스플래시 overlay 를 해제하고 escalation 타이머(5초)를 취소한다.
 * best-effort 계약 — 결과 콜백이 없으므로 성공 여부와 무관하게 1회만 시도한다.
 */
export const notifyWebReady = (): void => {
  if (notified) return;
  notified = true;

  try {
    const platform = appType();
    if (platform === "iOS") {
      window.webkit?.messageHandlers?.webReadyHandler?.postMessage({});
    } else if (platform === "Android") {
      window.maketrend?.webReady?.();
    }
  } catch {
    // best-effort 계약 — native 호출 실패가 JS 부트스트랩을 깨면 안 된다 (재시도 없음).
  }
};
